import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';

import { CourseContainer } from '../../course';
import { QuestionPage, QuestionByIdPage } from '../../qr';
import Podcast from '../../main/podcast/main';
import Cashback from '../cashback';
import User from '../../user';
import Questions from '../../questions';
import NewQuestions from '../../new-questions';
import ViewQuestion from '../../new-questions/ViewQuestion';
import CourseDetailSwitcher from '../../course/ClassContent/CourseDetailSwitcher';
import notifications from '../../notifications';
import lectures from '../../lectures';

function MainRoutes() {
  return (
    <Switch>
      <Route exact path="/courses" component={CourseContainer} />
      <Route
        path="/courses/:courseId/:courseClassId?/:currentClassId?"
        component={CourseDetailSwitcher}
      />
      <Route path="/lectures/:courseId/:courseClassId/:testId" component={lectures} />
      <Route path="/lectures/:courseId/:courseClassId?" component={lectures} />
      <Route path="/qr/question/:id" component={QuestionByIdPage} />
      <Route path="/qr/:questionCode" component={QuestionPage} />
      <Route path="/podcast" component={Podcast} />
      <Route path="/cashback" component={Cashback} />
      <Route path="/user" component={User} />
      <Route path="/user/pass" component={User} />
      <Route path="/questions" component={Questions} />
      <Route exact path="/new-questions" component={NewQuestions} />
      <Route path="/new-questions/:id" component={ViewQuestion} />
      <Route path="/notifications" component={notifications} />
      <Redirect to="/courses" />
    </Switch>
  );
}

export default MainRoutes;
